// extracted by mini-css-extract-plugin
export default {"bp-small":"768px","header":"PageHeader-module__header___1aZuM","fontoverride":"PageHeader-module__fontoverride___2oeNn"};